import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Text, InputSearch, Card, Skeleton } from '@mercai/clever'

import type { SelectSaleOrdersFormProps } from './select-sale-orders-form.type'

import styles from './select-sale-orders-form.module.css'
import { useSaleOrderVariantList } from '@/services'
import { SaleOrderCard } from './components'
import { checkIfChecked } from './select-sale-orders-form.constants'
import { SaleOrderProps } from '@/types'

export const SelectSaleOrdersForm = ({
  onChangeValues,
  values = [],
  errors,
  filters,
}: SelectSaleOrdersFormProps) => {
  const { t } = useTranslation('componentSelectSaleOrdersForm')

  const [search, setSearch] = useState('')

  const { data, isLoading } = useSaleOrderVariantList({
    variantFields: 'search',
    search,
    ...filters,
  })

  const onHandleChange = (item: SaleOrderProps) => {
    const found = values?.find((saleOrder) => saleOrder?.uuid === item?.uuid)
    if (found) {
      onChangeValues(
        values.filter((saleOrder) => saleOrder?.uuid !== item?.uuid),
      )
    } else {
      onChangeValues([...values, item])
    }
  }

  const showSaleOrders = !isLoading && data?.data?.results

  return (
    <div className={styles.core}>
      <InputSearch
        className={styles.input}
        value={search}
        onChange={setSearch}
        translations={{
          inputPlaceholder: t('inputSearchPlaceholder'),
        }}
      />

      {isLoading &&
        [0, 1, 2, 3, 4].map((number) => (
          <Card className={styles['loading-items']} key={number}>
            <Skeleton
              width="1rem"
              height="1rem"
              className={styles['loading-items-circle']}
            />

            <div className={styles['loading-items-content']}>
              <Skeleton width="100%" height="1.2rem" />

              <Skeleton width="100%" height="1rem" />
            </div>
          </Card>
        ))}

      {showSaleOrders &&
        values &&
        values?.map((item) => {
          const found = data?.data?.results?.find(
            (saleOrder) => saleOrder?.uuid === item?.uuid,
          )
          if (found) return null

          return (
            <SaleOrderCard
              saleOrder={item}
              onChange={() => onHandleChange(item)}
              value={true}
              key={item?.uuid}
              hasError={!!errors?.saleOrders}
            />
          )
        })}

      {showSaleOrders &&
        data?.data?.results?.map((saleOrder) => (
          <SaleOrderCard
            saleOrder={saleOrder}
            onChange={() => onHandleChange(saleOrder)}
            value={checkIfChecked(values, saleOrder?.uuid)}
            key={saleOrder?.uuid}
            hasError={!!errors?.saleOrders}
          />
        ))}

      {!isLoading && data?.data?.results?.length === 0 && !values && (
        <Text>{t('emptyLabel')}</Text>
      )}
    </div>
  )
}
